export default "__VITE_ASSET__SH2ls0$X__"